import React from "react";

const ErrorIcon: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <line x1="12" y1="6" x2="12" y2="14" stroke="#D93025" strokeWidth="2" />
    <circle cx="12" cy="18" r="1.5" fill="#D93025" />
  </svg>
);

export default ErrorIcon;
